// frontend/src/components/API/Store/bookAPI.js
import axios from 'axios';
import { getCsrfToken } from '../../../services/csrfTokenManager';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchBooks = async () => {
  try {
    const csrfToken = await getCsrfToken();
    const response = await axios.get(`${API_URL}/books`, {
      headers: {
        'X-CSRF-Token': csrfToken,
      },
      withCredentials: true,
    });
    return {
      success: true,
      books: response.data.books,
      totalBooks: response.data.totalBooks,
      currentPage: response.data.currentPage,
      totalPages: response.data.totalPages,
    };
  } catch (error) {
    console.error('Error fetching books:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'An error occurred while fetching books. Please try again later.',
    };
  }
};

export const fetchBookById = async (id) => {
  try {
    const csrfToken = await getCsrfToken();
    const response = await axios.get(`${API_URL}/books/${id}`, {
      headers: {
        'X-CSRF-Token': csrfToken,
      },
      withCredentials: true,
    });
    return {
      success: true,
      book: response.data,
    };
  } catch (error) {
    console.error('Error fetching book:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'An error occurred while fetching the book. Please try again later.',
    };
  }
};

export const createBook = async (bookData) => {
  try {
    const csrfToken = await getCsrfToken();
    const response = await axios.post(`${API_URL}/books`, bookData, {
      headers: {
        'X-CSRF-Token': csrfToken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    });
    return {
      success: true,
      book: response.data,
    };
  } catch (error) {
    console.error('Error creating book:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'An error occurred while creating the book. Please try again later.',
    };
  }
};

export const updateBook = async (id, bookData) => {
  try {
    const csrfToken = await getCsrfToken();
    const response = await axios.put(`${API_URL}/books/${id}`, bookData, {
      headers: {
        'X-CSRF-Token': csrfToken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    });
    return {
      success: true,
      book: response.data,
    };
  } catch (error) {
    console.error('Error updating book:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'An error occurred while updating the book. Please try again later.',
    };
  }
};

export const deleteBook = async (id) => {
  try {
    const csrfToken = await getCsrfToken();
    const response = await axios.delete(`${API_URL}/books/${id}`, {
      headers: {
        'X-CSRF-Token': csrfToken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    });
    return {
      success: true,
      book: response.data,
    };
  } catch (error) {
    console.error('Error deleting book:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'An error occurred while deleting the book. Please try again later.',
    };
  }
};

export const fetchCategories = async () => {
  try {
    const csrfToken = await getCsrfToken();
    const response = await axios.get(`${API_URL}/categories`, {
      headers: {
        'X-CSRF-Token': csrfToken,
      },
      withCredentials: true,
    });
    return {
      success: true,
      categories: response.data,
    };
  } catch (error) {
    console.error('Error fetching categories:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'An error occurred while fetching categories. Please try again later.',
    };
  }
};
